import {
    Group,
} from 'three';
import {GLTFLoader} from "three/addons";
import { DRACOLoader } from 'three/addons/loaders/DRACOLoader.js';

class DeskSetup extends Group {
    /**
     * @type {import('three').Object3D} desktop
     */
    desktop;

    constructor(tableHeight) {
        super();
        const height = tableHeight+1;


        const loader = new GLTFLoader();

        createSetup(this);

        function createSetup(group) {
            if (!group.desktop) {

                loader.load('/3ds/macbook-16/scene.gltf', function (gltf) {
                    const scale = 1;
                    group.desktop = gltf.scene;

                    group.desktop.traverse(function (node) {
                        if (node.isMesh) {
                            node.castShadow = true;
                            node.receiveShadow = true;
                        }
                    });
                    group.desktop.scale.set(scale * group.desktop.scale.x, scale * group.desktop.scale.y, scale * group.desktop.scale.z)
                    group.desktop.position.x = 0;
                    group.desktop.position.y = height;
                    group.desktop.position.z = 0;
                    group.desktop.receiveShadow = true;
                    group.desktop.castShadow = true;

                    group.add(group.desktop);
                }, undefined, function (error) {
                    console.error(error);
                });
            }
        }
    }

    updateHeight(height) {
        if (! this.desktop) {
            return;
        }

        this.desktop.position.y = height+1;
    }
}

export {DeskSetup};
